import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, tap, throwError } from 'rxjs';
import { signup } from '../models/signup';
import { postSignup, postUsernameData } from '../../shared/const';
import { Router } from '@angular/router';


@Injectable({
    providedIn: 'root'
})
export class SignupService {

    constructor(private http: HttpClient, private router: Router) { }

    postSignup(data: any): Observable<any> {
        return this.http.post<signup[]>(`${postSignup}`, data).pipe(
            tap((response: any) => {
              if(response.success = true){
                // this.router.navigate(['home']);
              }
              // localStorage.setItem('loggedInUser', JSON.stringify(response.payload));
            }),
        )
      }

      postUserName(user:any){
        return this.http.post<any>(`${postUsernameData}`, user )
      }
}